"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageCode = exports.BotSmsSetting = void 0;
var BotSmsSetting;
(function (BotSmsSetting) {
    BotSmsSetting["Off"] = "off";
    BotSmsSetting["BotOnly"] = "bot_only";
    // TODO: extend to allowing with two-way and escalation
})(BotSmsSetting = exports.BotSmsSetting || (exports.BotSmsSetting = {}));
var LanguageCode;
(function (LanguageCode) {
    LanguageCode["ENGLISH"] = "en";
    LanguageCode["SPANISH"] = "es";
})(LanguageCode = exports.LanguageCode || (exports.LanguageCode = {}));
